import React, { HTMLAttributes } from 'react';

import {
  Node,
} from '@uncinc/react-drupal-core';

import useClasses from '../../../hooks/useClasses';
import { Pager } from '../../../components';
import { GenericViewProps } from '..';

import './style.scss';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entities: GenericViewProps['entities'];
  pager: GenericViewProps['pager'];
  setCurrentPage: (currentPage: number) => void;
}

const ViewDiary: React.FC<Props> = ({
  entities,
  pager,
  setCurrentPage,
  className,
}) => {
  const { buildClass, joinClasses } = useClasses('ViewDiary');

  return (
    <div className={joinClasses(buildClass(), className)}>
      <ol className={buildClass('list')}>
        {entities.map((entity) => {
          const id = entity.getIn(['nid', 0, 'value']);
          const uuid: string = entity.getIn(['uuid', 0, 'value']);
          const langcode: string = entity.getIn(['langcode', 0, 'value']);

          return (
            <Node
              key={`${uuid}:${langcode}`}
              id={id}
              entity={entity}
              viewMode="teaser"
            />
          );
        })}
      </ol>

      {/*
        The pager expects the first page to be 1, however,
        the Drupal view gives us 0 as the first page.
        That's why we need to add 1 to the currentPage prop for the Pager and
        subtract 1 from the returned parameter in the setCurrentPage function.
      */}
      <Pager
        totalPages={pager.get('total_pages', 0)}
        currentPage={pager.get('current_page', 0) + 1}
        setCurrentPage={(page: number) => {
          setCurrentPage(page - 1);
          window.scrollTo(0, 0);
        }}
        marginPagesDisplayed={1}
        pageCount={2}
        pageRangeDisplayed={2}
      />
    </div>
  );
};

export default ViewDiary;
